module.exports = __webpack_public_path__ + "img/icn-callout-2.3179d22.3179d22e.svg";